import {Component, Input, OnInit} from '@angular/core';
import {FARES_FAMILY} from "@app/enums";
import { Passenger } from '@app/models';

/**
 * Componente para mostrar la información de un pasajero en la selección de equipaje.
 */
@Component({
    selector: 'am-bags-passenger',
    templateUrl: './am-bags-passenger.component.html',
    styleUrls: ['./am-bags-passenger.component.scss'],
    standalone: false
})
export class AmBagsPassengerComponent implements OnInit {

 /**
   * Familia tarifaria del pasajero, representada como una cadena de texto.
   * Este valor determina el tipo de tarifa del pasajero (por ejemplo, "Económica", "Business", etc.).
   * 
   * @type {string}
   */
 @Input() fareFamily: string;

 /**
  * Información del pasajero, representada por un objeto de tipo `Passenger`.
  * 
  * @type {Passenger}
  */
 @Input() passenger: Passenger;

 /**
  * Color de texto asociado a la familia tarifaria del pasajero.
  * Se utiliza para establecer dinámicamente el color del texto en la interfaz.
  * 
  * @type {string}
  */
 @Input() fareFamilyTextColor: string;

 /**
  * Ruta de la imagen asociada al pasajero o su tarifa.
  * Este valor puede ser asignado dinámicamente en función de la tarifa o el tipo de pasajero.
  * 
  * @type {string}
  */
 image: string = '';

 /**
  * Texto descriptivo adicional que se mostrará en la interfaz.
  * Este valor puede estar relacionado con la familia tarifaria o el pasajero.
  * 
  * @type {string}
  */
 text: string;

 /**
  * Enumeración que representa las diferentes familias tarifarias disponibles.
  * 
  * @type {FARES_FAMILY}
  */
 FARES_FAMILY: FARES_FAMILY;

  constructor() {
  }

  ngOnInit(): void {
  }

}
